import { SwitchProps } from "@hightouch/formkit";
import { SharedProps } from ".";
import { Controller } from "react-hook-form";
import { Box, Switch, Text } from "@hightouch/htui";

export const FKSwitch = ({
  name,
  label,
  isDisabled,
}: SwitchProps & SharedProps) => (
  <Controller
    name={name}
    render={({ field }) => (
      <Box alignItems="center" display="flex" gap={3}>
        <Switch
          aria-label={`Toggle ${label}.`}
          isChecked={Boolean(field.value)}
          isDisabled={isDisabled}
          onChange={(value) => field.onChange(value)}
        />
        <Text fontWeight="semibold">{label}</Text>
      </Box>
    )}
  />
);
